<div class="container app-foooter" *ngIf="showHead">
        <div class="row">
                <div class="col-md-2 text-center">
                        
                </div>
                <div class="col-md-8 text-center">
                        <p>Copyright © {{currentYear}}, Pro-Vigil, All rights reserved.</p>
                </div>
                <div class="col-md-2 text-center">
                        <p>Version {{releaseVersion}}</p>
                </div>
        </div>
</div>
